import React from "react"
import logoUrl from "../../../assets/img/payment-icons/american_express.svg"

export default function AmericanExpressLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="American Express logo"
            style={sx}
        />
    )
}
